import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import useApi from "utils/api";
import { useDateFilters } from "components/shared/filters/DateFilters/context/useDateFilters";
import { formatEvents } from "../../../Component/helpers/data/formatEvents";

export const useUsersEvents = (users?: any[]) => {
    const { authGet } = useApi();
    const { from, to } = useDateFilters();

    const userIds = useMemo(
        () => (users || []).map((user) => user?.id).filter(Boolean),
        [users]
    );

    const { data, isFetching } = useQuery({
        queryKey: ["/schedules/v2", {
            startDate: moment(from).isBefore(moment(), "date")
                ? moment().format("YYYY-MM-DD")
                : moment(from).format("YYYY-MM-DD"),
            endDate: moment(to).format("YYYY-MM-DD"),
            users: userIds,
            pagination: false,
            status: "approved",
        }],
        queryFn: ({ queryKey, signal }: any) => {
            const [url, params] = queryKey;
            return authGet(url, { params, signal });
        },
        enabled: !!from && !!to && userIds.length > 0 && moment(to).isSameOrAfter(moment(), "date"),
    });

    // only published shifts can be moved to open shifts or called off
    const events = useMemo(
        () => formatEvents((data?.data?.events || []).filter((event: any) => event?.status === "approved")),
        [data]
    );

    return {
        events: userIds.length > 0 ? events : [],
        loading: isFetching,
    };
};
